<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Quem somos';
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container clearfix text-justify">
        <span class="float-sm-left">
            <div>
                ​<picture class="image-gallery float-sm-left mr-20 pb-10" style="display: flex;">
					<img class="img-fluid" src="/assets/images/rodapeSede.jpg" alt="Sede da empresa">
                </picture>
            </div>            
        </span>	

		<p>Em 1988, após a realização de uma detalhada pesquisa de mercado, Attilio Stopassola verificou a falta de uma imobiliária competente especializada em administração e locação de imóveis. Decidiu então investir neste novo ramo de atividade, fundando em 01 de maio do mesmo ano a SP Administradora e Locadora de Bens Ltda., conhecida como SP Imobiliária.</p>
		<p>A SP Imobiliária iniciou suas atividades na Rua Felisberto Soares, 159, junto ao escritório de advocacia de Olício Port. Permaneceu neste local por seis meses, mudando-se para a Rua Osvaldo Aranha, 188, onde ficou estabelecida até outubro de 2002. Com a aquisição de sua sede própria, mudou-se para a Rua Felisberto Soares, 208, num prédio totalmente reformulado, objetivando proporcionar um ótimo ambiente para seus clientes, com uma área de mais de 600,00m², incluindo estacionamento próprio, auditório e duas salas de reuniões onde são realizadas várias atividades.</p>
		<hr>
        <h2 class="title color-primary mb-20">
            O nosso negócio é:
        </h2>
        <p>
            SOLUÇÕES EM SERVIÇOS HABITACIONAIS
        </p>
		<hr>
        <h2 class="title color-primary mb-20">
            A nossa missão é: 
        </h2>
        <p>
            "Oferecer serviços habitacionais com excelência, ética e profissionalismo, proporcionando satisfação aos clientes e colaboradores, contribuindo para uma sociedade sustentável". 
        </p>
		<hr>
        <h2 class="title color-primary mt-35 mb-20">
            Os nossos princípios são: 
        </h2>
        <ul>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                <b>Inovação:</b>  adequação constante às tendências de mercado;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                <b>Ética:</b>  trabalhar com transparência e honestidade;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                <b>Profissionalismo:</b>  saber fazer, utilizando os meios adequados;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                <b>Ambiente:</b>  proporcionar bem-estar, integração e satisfação das partes interessadas;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                <b>Comprometimento:</b>  busca pelos mesmos objetivos;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                <b>Responsabilidade Social:</b>  interagir beneficiando a sociedade.
            </li>
        </ul>
		<hr>
        <h2 class="title color-primary mb-20">
            A nossa visão é: 
        </h2>
        <p>
            "Ser referência no setor onde atua trabalhando com funcionários motivados, primando pela satisfação dos clientes".
        </p>
		<hr>
		<p>Venha conhecer a nossa sede, ou entre em contato conosco, teremos a maior satisfação em auxiliar para a realização de um ótimo negócio.</p>
		<br />
	</div>
</section>